<div class="action-dialog-container d-flex flex-column position-relative">
  <mat-icon class="close-button d-flex align-items-center justify-content-center"
            (click)="closeDialog(false)">
    close
  </mat-icon>

  <div class="d-flex flex-column">
    <span class="action-dialog-title">{{ data.title }}</span>
    <span class="action-dialog-description">{{ data.description }}</span>
  </div>
  <div class="d-flex flex-column gap-2">
    <button class="dialog-action-button py-2"
            (click)="closeDialog(true)">
      {{ data.actionButtonText }}
    </button>
    <button class="dialog-cancel-button py-2"
            (click)="closeDialog(false)">
      {{ data.cancelButtonText }}
    </button>
  </div>
</div>
